import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User { id: string; email: string; name: string; role: string; }
export const useAuthStore = create(persist(
  (set) => ({ token: null as string | null, user: null as User | null,
    setAuth: (token: string, user: User) => set({ token, user }),
    logout: () => set({ token: null, user: null }) }),
  { name: 'mimi-auth' }
));
